import { MMKV } from "react-native-mmkv";

export const mmkv = new MMKV();

export const storageAdapter = {
  setItem: (key: string, data: string) => mmkv.set(key, data),
  getItem: (key: string) => mmkv.getString(key),
  removeItem: (key: string) => mmkv.delete(key),
};
